/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import queryString from 'querystring';
import { GetTitle } from './boardTitle';
import { getBreadScrumb } from './breadscrumb';
import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';

export function ReplyWriter(routeProps: RouteComponentProps) {
  const dispatch = useDispatch();
  const option = queryString.decode(routeProps.location.search.substring(1));
  const reply = option.reply?.toString();

  useEffect(() => {
    if (window.localStorage.getItem('token') === null && option.ctgy === 'qna') {
      dispatch(toast.error({ message: '로그인이 필요합니다.' }));
      routeProps.history.push('/login');
    } else if (option.update !== undefined && option.update) {
      const boardItem: any = routeProps.location.state;
      setTitleText(boardItem.subject);
      setContextText(boardItem.content);
    }
  }, []);

  const [attacheFile, setAttacheFile] = useState<FileList>();

  const [titleText, setTitleText] = useState('');
  const [userText, setUserText] = useState(window.localStorage.getItem('name') || '');
  const [contextText, setContextText] = useState('');

  const onClickValidation = () => {
    if (!titleText) {
      dispatch(toast.error({ message: '제목을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (!contextText) {
      dispatch(toast.error({ message: '내용을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    onClickSave();
  };

  const onClickSave = () => {
    if (option.update !== undefined && option.update) {
      server
        .updateReply(option.ctgy.toString(), option.id.toString(), {
          subject: titleText,
          content: contextText,
        })
        .then(() => {
          const r = {
            id: option.id.toString(),
            ctgy: option.ctgy.toString(),
            title: option.title.toString(),
            subTitle: option.subTitle.toString(),
          };

          routeProps.history.push({
            pathname: '/board/replyView',
            search: `?${new URLSearchParams(r).toString()}`,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      server
        .writeReplyBoard(option.ctgy.toString(), option.id.toString(), {
          subject: titleText,
          content: contextText,
          attach1: '',
          attach2: '',
          attach3: '',
          attach4: '',
          attach5: '',
        })
        .then(() => {
          routeProps.history.push(`/board/${option.ctgy.toString()}`);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  // const attachFileDom = () => {
  //   if (reply === undefined) {
  //     return (
  //       <li>
  //         <span>첨부파일</span>
  //         <div className="input-file-container">
  //           <input
  //             className="input-files"
  //             id="file01"
  //             type="file"
  //             multiple
  //             onChange={(dom) => {
  //               if (dom.target !== null && dom.target.files !== null) {
  //                 if (dom.target.files.length > 5) {
  //                   dispatch(toast.error({ message: '파일은 5개까지만 선택이 가능합니다.' }));
  //                   return;
  //                 }
  //                 for (let i = 0; i < dom.target.files.length; i++) {
  //                   // 동적으로 file list, delete btn 생성
  //                 }
  //                 setAttacheFile(dom.target.files);
  //               }
  //             }}
  //           />
  //           {/* <label tabIndex={0} htmlFor="file01" className="input-file-trigger">
  //             파일 선택
  //           </label> */}
  //         </div>
  //         {/* <small className="file-return" /> */}
  //       </li>
  //     );
  //   }
  //   return <></>;
  // };

  return (
    <div className="content">
      {getBreadScrumb(option.title.toString())}
      {GetTitle(
        option.ctgy.toString(),
        option.title.toString(),
        option.subTitle.toString(),
        '',
        '',
        false,
        () => {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (param: string) => {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (param: string) => {}
      )}
      <ul className="inputs">
        <li>
          <span>제목</span>
          <input
            className="full"
            type="text"
            value={titleText}
            onChange={(dom) => {
              setTitleText(dom.target.value);
            }}
          />
        </li>
        <li>
          <span>작성자</span>
          <input type="text" readOnly value={userText} />
        </li>
        {/* {attachFileDom()} */}
        <li>
          <textarea
            name=""
            id=""
            rows={20}
            value={contextText}
            onChange={(dom) => {
              setContextText(dom.target.value);
            }}
          />
        </li>
      </ul>
      <div className="buttons">
        <button
          className="btn-sub"
          type="button"
          onClick={() => {
            routeProps.history.goBack();
          }}
        >
          취소
        </button>
        <button
          className="btn-main"
          type="button"
          onClick={() => {
            onClickValidation();
            // if (option.update !== undefined && option.update) {
            //   server
            //     .updateReply(option.ctgy.toString(), option.id.toString(), {
            //       subject: titleText,
            //       content: contextText,
            //     })
            //     .then((payload) => {
            //       if (!payload) {
            //         dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
            //       } else if (payload.code === 260 || payload.code === 500) {
            //         dispatch(toast.error({ message: '파라미터 오류' }));
            //       } else {
            //         routeProps.history.go(-2);
            //       }
            //     });
            // } else {
            //   console.log(`${titleText}:${passWordText}:${emailText}:${contextText}`);
            // }
          }}
        >
          등록하기
        </button>
      </div>
    </div>
  );
}
